import React, { memo } from "react";
import PropTypes from "prop-types";

import PhotoGridItem from "../PhotoGridItem/index";
import { PhotoGridItemStyle } from "../styles";

export const PhotoRowGridItem = ({ photo, width, height, gridItemComponent, useRouterLink }) => {
    let GridItemComponent;

    if (gridItemComponent) {
        GridItemComponent = gridItemComponent;
    } else {
        GridItemComponent = PhotoGridItem;
    }

    let { ratio } = photo;

    return (
        <PhotoGridItemStyle
            data-testid="photo-grid-item"
            ratio={ratio}
            style={{
                width,
                height
            }}
        >
            <GridItemComponent photo={photo} useRouterLink={useRouterLink} />
        </PhotoGridItemStyle>
    );
};

PhotoRowGridItem.propTypes = {
    photo: PropTypes.shape({
        ratio: PropTypes.number.isRequired
    }).isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    gridItemComponent: PropTypes.element,
    useRouterLink: PropTypes.bool
};

export default memo(PhotoRowGridItem);
